import { IoIosArrowBack, IoIosArrowDropleftCircle } from 'react-icons/io'

import { HiClipboardDocumentList, HiFlag, HiMiniUser, HiMiniUserGroup } from 'react-icons/hi2'
import { Card } from '../Card/card'
import { Pills } from '../Pills/pills'
import { Board } from '../Board/board'
import { useCallback, useEffect, useState } from 'react'
import Assessment from '../../../API/Assessment/index'
import { ModalAssessment } from '../Modal/modalAssessment'
import Loading from '../../Loading/Loading'
import { competenceResultTranslate } from '../../../i18n/translatedMessages'
import { translate as translateDimensions } from '../../../i18n/Library/dimensionsWitMeGrow'
import { useIntl } from 'react-intl'
import { MdArrowForwardIos } from 'react-icons/md'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import EmptyInformation from '../../../Views/Employee/Components/EmptyInformation/EmptyInformation'

const assets = {
	Organizacional: {
		'small-icon': <HiClipboardDocumentList />,
		icon: <HiClipboardDocumentList size={28} />,
		color: '#008ACD',
		subColor: '#79bad9',
	},
	Persona: {
		'small-icon': <HiMiniUser />,
		icon: <HiMiniUser size={28} />,
		color: '#D87706',
		subColor: '#edbf8a',
	},
	Líder: {
		'small-icon': <HiFlag />,
		icon: <HiFlag size={28} />,
		color: '#00A28B',
		subColor: '#75c7bb',
	},
	Social: {
		'small-icon': <HiMiniUserGroup />,
		icon: <HiMiniUserGroup size={28} />,
		color: '#6C4FDB',
		subColor: '#9d8cdb',
	},
}

const mockCompetence = [
	{
		title: 'Organizacional',
		color: '#008acd',
		items: [
			{
				title: 'ORIENTACIÓN AL CLIENTE',
				text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
			},
			{
				title: 'PENSAMIENTO ESTRATÉGICO',
				text: 'Es un proceso dinámico, flexible, que permite y hasta fuerza modificaciones en los planes, a fin de responder a las cambiantes circunstancias.',
			},
			{
				title: 'NEGOCIACIÓN EFECTIVA',
				text: 'Es un proceso en el que dos o más personas intercambian ideas con la intención de modificar sus relaciones y alcanzar un acuerdo tendiente a satisfacer necesidades mutuas.',
			},
			{
				title: 'CREATIVIDAD E INNOVACIÓN',
				text: 'La creatividad como habilidad para imaginar y conceptualizar ideas nuevas y originales, y la innovación como habilidad para que esas ideas se incorporen en nuestra vida, con el fin de hacerla más sencilla.',
			},
			{
				title: 'GESTIÓN EFECTIVA DEL TIEMPO',
				text: 'Habilidad para equilibrar las tareas diarias, fijando prioridades, con el fin de lograr una mayor productividad y eficiencia.',
			},
		],
	},

	{
		title: 'Social',
		color: '#6c4fdb',
		items: [
			{
				title: 'INCLUSIÓN Y DIVERSIDAD',
				text: 'La diversidad como el conjunto de características que nos hacen diferentes a los demás y la inclusión como la mezcla que hace que esas diferencias funcionen juntas.',
			},
			{
				title: 'COMUNICACIÓN EFECTIVA',
				text: 'Es la capacidad de escuchar, comprender e interpretar de manera correcta la información de otro y a la vez de transmitir de manera adecuada, asegurándose de que el mensaje sea recibido.',
			},
			{
				title: 'RELACIONES INTERPERSONALES',
				text: 'Las relaciones implican gestionar emociones positivas y negativas, propias y de otros, con el fin de enfrentarse a sucesos desagradables y también a sucesos emocionantes.',
			},
			{
				title: 'TRABAJO EN EQUIPO',
				text: 'Capacidad de lograr objetivos compartidos por todos los integrantes de manera consciente, mancomunada, coordinada y colaborativa.',
			},
			{
				title: 'ORIENTACIÓN A RESULTADOS',
				text: 'La capacidad para encaminar todos los actos hacia la meta esperada, actuando con velocidad y sentido de urgencia ante decisiones importantes necesarias.',
			},
		],
	},

	{
		title: 'Líder',
		color: '#00a28b',
		items: [
			{
				title: 'VISIÓN INSPIRADORA',
				text: 'Actitud de curiosidad y apertura, con el fin de lograr un aprendizaje de cada situación a lo largo de la vida.',
			},
			{
				title: 'TOMA DE DECISIONES',
				text: 'Vivir significa elegir; no tomar decisiones implica inmovilidad y bloqueo. Muchas veces funciona la intuición: tomar decisiones con el corazón y utilizar la mente para que funcionen.',
			},
			{
				title: 'GESTIÓN DEL CAMBIO',
				text: 'La gestión del cambio busca facilitar y conseguir la implementación exitosa de los procesos de transformación, lo que implica trabajar con y para las personas en la aceptación y asimilación de los cambios y en la reducción de la resistencia a los mismos.',
			},
			{
				title: 'LÍDER COACH',
				text: 'Busca mostrar nuevas posibilidades a sus equipos, ayudándolos a tomar decisiones que antes no eran obvias para ellos.',
			},
		],
	},

	{
		title: 'Persona',
		color: '#d87706',
		items: [
			{
				title: 'RESILIENCIA',
				text: 'Las personas que lo son no creen que exista una vida dura, sino momentos difíciles.',
			},
			{
				title: 'FLEXIBILIDAD',
				text: 'Habilidad de reconocer un entorno en el cual lo único constante es el cambio y a su vez, tener la plasticidad para adaptar las conductas, decisiones, estrategias, y relaciones a dicho entorno y sus necesidades.',
			},
			{
				title: 'APRENDIZAJE CONTINUO',
				text: 'Se refiere a la actitud de curiosidad y apertura para el aprendizaje a lo largo de la vida.',
			},
			{
				title: 'EMPATÍA',
				text: 'Es el arte consciente de crear puentes de vulnerabilidad y compasión `con` y `para` el otro.',
			},
			{
				title: 'BALANCE DE VIDA PERSONAL-LABORAL',
				text: 'Armonía entre el desarrollo profesional y las metas personales, con el fin de que el ser humano se siente protagonista de su destino y bienestar integral.',
			},
			{
				title: 'AUTOCONOCIMIENTO',
				text: 'Capacidad para percibirse a uno mismo y al entorno de una manera consciente.',
			},
		],
	},
]

export function CompetenceResult({ onCloseResult, employee, mandalaView = false }) {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const [loading, setLoading] = useState(false)
	const [keywords, setKeywords] = useState(null)
	const [dimensions, setDimensions] = useState(null)
	const [selectedDimension, setDimension] = useState(null)
	const [show, setShow] = useState(true)
	const [strengthWeakness, setStrengthWeakness] = useState(null)
	const [allScores, setAllScores] = useState(null)
	const [mergedCompetence, setMergedCompetence] = useState([])

	const handleDimension = dimension => {
		setDimension(dimension)
		setShow(true)
	}

	const loadData = useCallback(async () => {
		try {
			setLoading(true)
			const [getKeywords, getDimensions, getStrengthWeakness, getAllScore] = await Promise.all([
				Assessment.getKeywords(employee.id),
				Assessment.getDimensions(employee.id),
				Assessment.getStrengthWeakness(employee.id),
				Assessment.getStrengthWeaknessAllScore(employee.id),
			])

			setAllScores(getAllScore)
			setKeywords(getKeywords)
			setDimensions(getDimensions)
			setStrengthWeakness(getStrengthWeakness)
		} catch {
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	useEffect(() => {
		const updatedCompetence = mockCompetence.map(competence => {
			const dimensionScore = dimensions?.find(dimension => dimension.dimension === competence.title)

			const updatedItems = competence?.items?.map(item => {
				const strengthScore = allScores?.strengths?.find(strength => strength.description === item.title)
				const weaknessScore = allScores?.weaknesses?.find(weakness => weakness.description === item.title)

				const score = strengthScore ? strengthScore.score : weaknessScore ? weaknessScore.score : null

				return {
					...item,
					score,
				}
			})

			return {
				...competence,
				score_relative: dimensionScore ? dimensionScore.score_relative : null,
				items: updatedItems,
			}
		})

		const sortedCompetence = updatedCompetence.sort((a, b) => (b.score_relative || 0) - (a.score_relative || 0))

		setMergedCompetence(sortedCompetence)
	}, [mockCompetence, allScores, dimensions])

	if (loading) return <Loading />

	return (
		<>
			{dimensions && dimensions.length > 0 ? (
				<>
					{!mandalaView && (
						<>
							<div className='tw-flex tw-items-center tw-justify-between tw-mb-5'>
								<div className='tw-flex tw-space-x-4 tw-items-center'>
									<button
										onClick={onCloseResult}
										className='tw-rounded-full tw-text-purple-500 tw-p-1 tw-w-[32px] tw-h-[32px] tw-bg-white hover:tw-bg-purple-500 hover:tw-text-white tw-flex tw-items-center tw-justify-center border border-primary'
									>
										<IoIosArrowBack />
									</button>
									<div className='tw-text-xl'>{employee.name}</div>
								</div>
							</div>

							<div className='tw-my-9 tw-text-lg'>{competenceResultTranslate.competenceResultText}</div>
						</>
					)}
					<div className='tw-space-y-10'>
						<div>
							<div className='tw-p-4 tw-bg-gray-100 tw-font-bold tw-text-xl tw-mb-5'>{competenceResultTranslate.competenceResultWordTitle}</div>
							<div className='tw-flex tw-items-center tw-justify-center'>
								<div className='tw-grid  tw-gap-2 tw-grid-cols-2 lg:tw-gap-3 lg:tw-grid-cols-3'>
									{keywords?.map(item => (
										<Pills label={item.description} key={item.description} color='#008ACD' />
									))}
								</div>
							</div>
						</div>

						<div>
							<div className='tw-p-4 tw-bg-gray-100 tw-font-bold tw-text-xl tw-mb-5'>{competenceResultTranslate.competenceResultDimensionsTitle}</div>
							<div className='tw-flex tw-justify-center tw-gap-4'>
								{dimensions?.map(item => (
									<Card content={item} key={item.dimension} assets={assets} handleDimension={handleDimension} />
								))}
							</div>
						</div>

						{dimensions && (
							<div>
								<div className='tw-p-4 tw-bg-gray-100 tw-font-bold tw-text-xl tw-mb-5'>
									{competenceResultTranslate.competenceResultStrenghtsWeakness}
								</div>
								{/* <div className='tw-my-9 tw-text-lg'>{competenceResultTranslate.competenceResultDesc}</div> */}
								<div className='tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-4'>
									<Board assest={assets} content={dimensions[0]} title='Fortalezas' list={strengthWeakness.strengths} />
									<Board
										assest={assets}
										content={dimensions[3]}
										title={language === 'pt' ? 'Oportunidades de Melhora' : 'Oportunidades de Mejora'}
										list={strengthWeakness.weaknesses}
									/>
								</div>
								<Link to='/app/services/development-guide'>
									<div className='tw-px-4 tw-rounded-full tw-py-4 tw-text-center tw-bg-purple-500 tw-shadow-md tw-cursor-pointer tw-w-full'>
										<div className='tw-text-white tw-flex tw-items-center tw-justify-center'>
											{language === 'pt' ? 'Ver Guia de Desenvolvimento' : 'Ver Guía de Desarrollo'}
											<MdArrowForwardIos className='tw-ml-2' />
										</div>
									</div>
								</Link>
							</div>
						)}

						<div>
							<div className='tw-p-4 tw-bg-gray-100 tw-font-bold tw-text-xl tw-mb-5'>{competenceResultTranslate.competenceResultGrade}</div>
							<div className='tw-my-9 tw-text-lg'>{competenceResultTranslate.competenceResultGradeDesc}</div>
							<div className='tw-w-full tw-space-y-4'>
								<div className='tw-w-full tw-space-y-4'>
									{mergedCompetence.map((dimension, index) => {
										const barColor = assets[dimension.title]?.color || '#000000'
										const subBarColor = assets[dimension.title]?.subColor || '#000000'

										return (
											<div key={index}>
												<div className='tw-font-semibold tw-text-lg tw-text-gray-700 tw-pt-5'>
													{translateDimensions[language][dimension.title]} - {dimension.score_relative}%
												</div>
												<div className='tw-w-full tw-bg-gray-300 tw-rounded-full'>
													<div
														className='tw-h-4 tw-bg-gray-300 tw-rounded-full tw-shadow-md'
														style={{
															width: `${dimension.score_relative}%`,
															backgroundColor: barColor,
														}}
													/>
												</div>

												<div className='tw-mt-4 tw-grid tw-grid-cols-2 tw-gap-4'>
													{dimension.items.map((item, itemIndex) =>
														item.score ? (
															<div key={itemIndex} className='tw-bg-white tw-rounded-lg tw-p-4 tw-text-sm tw-shadow-md'>
																<div className=''>{item.score ? `${translateDimensions[language][item.title]} - ${item.score * 5}%` : ''}</div>
																{item.score && (
																	<div className='tw-w-full tw-bg-gray-200 tw-rounded-full tw-mt-2'>
																		<div
																			className='tw-h-2 tw-rounded-full'
																			style={{
																				width: `${item.score * 5}%`,
																				backgroundColor: subBarColor,
																			}}
																		/>
																	</div>
																)}
															</div>
														) : (
															''
														)
													)}
												</div>
											</div>
										)
									})}
								</div>
							</div>
							<div className='tw-grid tw-grid-cols-2 tw-gap-4'></div>
						</div>
					</div>
					<ModalAssessment
						show={show}
						setShow={setShow}
						assets={assets}
						content={dimensions}
						selectedDimension={selectedDimension}
						setNewDimension={setDimension}
					/>
				</>
			) : mandalaView ? (
				<div className='col mt-3'>
					<EmptyInformation />
				</div>
			) : (
				<div className='tw-text-center tw-text-lg tw-p-4'>Error al cargar los datos. Inténtalo de nuevo más tarde.</div>
			)}
		</>
	)
}
